import { styled } from 'baseui';
import type { Theme as ThemeT } from 'baseui/theme';
export const RTEWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  position: 'relative',
  fontFamily: 'UberMoveText,Helvetica,Arial,sans-serif'
});
export const StyledReactQuill = styled<'section', {
  $styles?: {
    minHeight?: string;
  };
}>('section', ({
  $theme,
  $styles
}: {
  $theme: ThemeT;
  $styles?: {
    minHeight?: string;
  };
}) => ({
  width: '100%',
  '.ql-toolbar.ql-snow + .ql-container.ql-snow': {
    border: 0,
    height: 'auto'
  },
  '.quill .ql-toolbar.ql-snow': {
    border: 0,
    borderBottom: `1px solid ${$theme.colors.borderOpaque}`,
    display: 'flex',
    flexWrap: 'wrap',
    fontFamily: 'UberMoveText,Helvetica,Arial,sans-serif',
    paddingBottom: 0
  },
  '.quill .ql-snow .ql-editor:focus': {
    outline: 0,
    boxShadow: `0px 0px 0px 2px ${$theme.colors.accent400} inset`
  },
  '.ql-snow .ql-editor': {
    minHeight: $styles?.minHeight,
    color: $theme.colors.contentPrimary,
    resize: 'vertical'
  },
  '.ql-snow .ql-editor:focus': {
    outline: `${$theme.sizing.scale0} solid ${$theme.colors.accent400}`
  },
  '.ql-toolbar.ql-snow .ql-formats': {
    display: 'flex',
    marginRight: '15px',
    border: `1px solid ${$theme.colors.borderOpaque}`,
    borderRadius: $theme.borders.radius200,
    margin: `${$theme.sizing.scale100} 0px ${$theme.sizing.scale300} ${$theme.sizing.scale400}`
  },
  '.quill .ql-snow .ql-fill, .quill .ql-snow .ql-stroke.ql-fill': {
    fill: $theme.colors.contentTertiary
  },
  '.quill .ql-snow .ql-stroke': {
    stroke: $theme.colors.contentTertiary
  },
  '.quill .ql-snow .ql-picker': {
    color: $theme.colors.contentTertiary
  },
  '.quill .ql-snow .ql-picker-options': {
    backgroundColor: $theme.colors.backgroundTertiary
  }
}));